import * as types from './mutations-type'
import AccountService from '../service/account.service'
import BizService from '../service/biz.service'
import ConfigService from '../service/config.service'

const actions = {
  /**
   * 获取当前时间戳
   */
  getNowTime ({ state, commit }) {
    return ConfigService.getTime().then(res => {
      commit(types.SET_NOW_TIME, res.time)
      return res
    })
  },
  /**
   * 获取 Layout 导航数据
   */
  getLayoutNav ({ state, commit }) {
    return ConfigService.getNavList().then(res => {
      commit(types.SET_LAYOUT_NAV, {
        notice: res.notice,
        header: res.top,
        footer: res.bot,
        bus: res.bus
      })
      return res
    })
  },
  /**
   * 获取用户信息或者企业信息
   */
  getSigninInfo ({ state, commit }) {
    // 这里没通过 loginDomain === biz 判断，是因为调登录接口的时机比 loginDomain的赋值要早
    const getSigninInfo = window.location.host === 'b.geekbang.org'
      ? BizService.getCorporateInfo
      : AccountService.getSigninInfo

    return getSigninInfo().then(res => {
      commit(types.LOGIN, res)
      return res
    })
  },
    /**
   * 获取用户信息 infoq 业务层的
   */
  getUserInfo ({state, commit}) {
    return AccountService.getUserIdentity().then(res => {
      commit(types.SET_USER_INFO, res)
      return res
    })
  },
  /**
   * 登出
   */
  logout ({ state, commit }) {
    return AccountService.logout().then(res => {
      commit(types.LOGOUT)
      location.reload()
      return true
    }).catch(() => {
      commit(types.LOGOUT)
      location.reload()
      return true
    })
  },
  /**
   * 获取手机区号列表
   */
  getPhoneList ({ state, commit }) {
    return ConfigService.getPhoneList().then(res => {
      commit(types.SET_PHONE_LIST, res)
      return res
    })
  },
    /**
   * 触发页面中的回调动作
   */
  getPageAction ({state, commit}, cb) {
    if (state.pageAction) {
      cb && cb(state.pageAction)
    }
    commit(types.SET_PAGE_ACTION, null)
  }
}

export default actions
